import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef, useMemo } from "react";
import {
    collection,
    query,
    where,
    getDocs,
    onSnapshot,
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import logo_default from "../../assets/logo_default.jpg";
import CopyUID from "../../components_root/copyuid";
import { Toast } from "../../components_root/ToastContext";
import { MdOutlineVerifiedUser, MdClose } from "react-icons/md";
import "../../body_root/popup.css";

export default function Account_list_profile_popup({ isOpen, onClose }) {
    const panelRef = useRef(null);
    const { Toastshow } = Toast();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [accountData, setAccountData] = useState([]);
    const [searchText, setSearchText] = useState("");

    const serviceTableName = "accountingfinancedb";

    // 🔹 LOAD DATA ON OPEN
    useEffect(() => {
        if (!isOpen) return;

        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) {
            setIsLoading(false);
            return;
        }

        setIsLoading(true);

        const ledgerQuery = query(
            collection(db, serviceTableName, select_company_uid, "ledger_accounts"),
            where("status", "==", true)
        );

        const unsubscribe = onSnapshot(
            ledgerQuery,
            async (snapshot) => {
                try {
                    if (snapshot.empty) {
                        setAccountData([]);
                        return;
                    }

                    const merged = await Promise.all(
                        snapshot.docs.map(async (docSnap) => {
                            const ledgerData = {
                                id: docSnap.id,
                                ...docSnap.data(),
                            };

                            // 🔥 skip master accounts
                            if (ledgerData.account_type === "master") return null;

                            let accountInfo = {};

                            // ✅ FIXED FIELD
                            if (ledgerData.accountguid) {
                                const accSnap = await getDocs(
                                    query(
                                        collection(db, "accounts"),
                                        where("status", "==", true),
                                        where("guid", "==", ledgerData.accountguid)
                                    )
                                );

                                if (!accSnap.empty) {
                                    accountInfo = {
                                        id: accSnap.docs[0].id,
                                        ...accSnap.docs[0].data(),
                                    };
                                }
                            }

                            return {
                                ...ledgerData,
                                account_info: accountInfo,
                            };
                        })
                    );

                    setAccountData(merged.filter(Boolean));
                } catch (err) {
                    console.error(err);
                    Toastshow("Error loading accounts", "error");
                } finally {
                    setIsLoading(false);
                }
            },
            (error) => {
                console.error(error);
                setIsLoading(false);
            }
        );

        return () => unsubscribe();
    }, [isOpen]);

    // 🔹 SEARCH FILTER
    const filteredAccounts = useMemo(() => {
        if (!searchText.trim()) return accountData;

        const q = searchText.toLowerCase();

        return accountData.filter((row) => {
            const name = row.account_info?.name?.toLowerCase() || "";
            const mobile = row.account_info?.mobile?.toString() || "";
            const accountNumber = row.accountnumber?.toString() || "";

            return (
                name.includes(q) ||
                mobile.includes(q) ||
                accountNumber.includes(q)
            );
        });
    }, [searchText, accountData]);

    return (
        <div className={`div-popup-body ${isOpen ? "show" : ""}`}>
            <div
                ref={panelRef}
                className={`overflow-auto div-panel-right ${
                    isOpen ? "slide-in" : "slide-out"
                }`}
            >
                {/* Header */}
                <div className="b-bottom items-back">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="button-ui0 text-h2 bold p-2 fcap">
                                        <MdOutlineVerifiedUser className="icon" /> Profile
                                    </div>
                                </td>
                                <td width={30}>
                                    <div onClick={onClose} className="button-ui0 p-2 cursor">
                                        <MdClose className="icon" />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Search */}
                <div className="p-2">
                    <input
                        type="search"
                        placeholder="Search by name, mobile or account number"
                        className="input-ui w-100"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                    />
                </div>

                {/* Content */}
                <div className="p-1">
                    {isLoading ? (
                        <div className="text-h2 bold">Loading...</div>
                    ) : filteredAccounts.length === 0 ? (
                        <div className="text-h2 bold">No Record Found</div>
                    ) : (
                        filteredAccounts.map((row) => (
                            <div className="b-bottom" key={row.id}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td width={30}>
                                                <img
                                                    src={
                                                        row.account_info?.photoURL ||
                                                        logo_default
                                                    }
                                                    alt="logo"
                                                    className="icon-photo-30"
                                                />
                                            </td>
                                            <td>
                                                <table className="fcap">
                                                    <tbody>
                                                        <tr>
                                                            <td className="bold">
                                                                {row.account_info?.name ||
                                                                    row.name ||
                                                                    "N/A"}
                                                            </td>
                                                            <td width={100} className="text-h3 bold">
                                                                {row.account_type
                                                                    ?.replaceAll("_", " ") ||
                                                                    "N/A"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <div className="button-ui0 p-0">
                                                                    {row.accountnumber || "N/A"}{" "}
                                                                    <CopyUID
                                                                        id={row.accountnumber || "N/A"}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td width={100}>
                                                                {row.account_info?.mobile || ""}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}
